import React from "react"

import MediaWrapper from "@/components/MediaWrapper"
import WistiaVideoEmbed from "@/components/WistiaVideoEmbed"

const IntegrationCarouselVideo = ({ data }) => {
  return data.wistia_video_id ? (
    <WistiaVideoEmbed
      key={data.wistia_video_id}
      videoId={data.wistia_video_id}
      posterImage={data.wistia_video_poster}
    />
  ) : (
    <MediaWrapper key={data.youtube_url}>
      <iframe
        src={data.youtube_url}
        width="100%"
        height="600px"
        className="integration-carousel__image"
      />
    </MediaWrapper>
  )
}

export default IntegrationCarouselVideo
